import "./category.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CategoryBar({ setCategory }) {

  const [openMenu, setOpenMenu] = useState(null);

  const navigate = useNavigate();

  const openProduct = (item) => {

    setCategory(item);

    navigate(
      `/?category=${encodeURIComponent(item)}`
    );

    setOpenMenu(null);
  };

  const menus = [

    {
      name: "Kratom",
      items: [
        "Kratom Powder",
        "Kratom Capsules",
        "Kratom Extract"
      ]
    },

    {
      name: "CBD",
      items: [
        "CBD Gummies",
        "CBD Oils",
        "CBD Flower"
      ]
    },

    {
      name: "THC",
      items: [
        "THC Gummies",
        "THC Vapes",
        "THCA Flower"
      ]
    },

    {
      name: "Legal Delta 9",
      items: [
        "Delta 9 Gummies",
        "Delta 9 Vape",
        "Delta 9 Flower"
      ]
    },

    {
      name: "Smoke Shop",
      items: [
        "Grinders",
        "Pre-Rolls",
        "Vapes",
        "Accessories"
      ]
    }

  ];

  return (

    <div className="category-bar">

      {/* ALL */}
      <div
        className="menu-item"
        onClick={() => openProduct("All")}
      >
        All
      </div>

      {/* MENUS */}
      {menus.map((menu, index) => (

        <div
          className="dropdown"
          key={index}
          onMouseEnter={() =>
            setOpenMenu(index)
          }
          onMouseLeave={() =>
            setOpenMenu(null)
          }
        >

          <div className="menu-item">
            {menu.name} ▼
          </div>

          <div
            className={`dropdown-content ${
              openMenu === index
                ? "show"
                : ""
            }`}
          >

            {menu.items.map((item, i) => (

              <div
                key={i}
                className="dropdown-item"
                onClick={() =>
                  openProduct(item)
                }
              >
                {item}
              </div>

            ))}

          </div>

        </div>

      ))}

      {/* SINGLE CATEGORY */}
      <div
        className="menu-item"
        onClick={() =>
          openProduct("BlueLotus")
        }
      >
        BlueLotus
      </div>

      {/* SINGLE CATEGORY */}
      <div
        className="menu-item"
        onClick={() =>
          openProduct("7-HYDROXY")
        }
      >
        7-HYDROXY
      </div>

    </div>
  );
}